<template>
  <v-dialog
    v-model="menu2"
    class="poppins"
    transition="dialog-bottom-transition"
    style="z-index: 33333 !important"
    content-class="d-flex justify-content-center align-items-center elevation-0"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        readonly
        outlined
        :label="$t('date_range')"
        append-icon="mdi-calendar"
        clearable
        dense
        v-bind="attrs"
        v-on="on"
        :value="inputValue"
        :error-messages="errorMessages"
        @blur="() => onBlur()"
      />
    </template>
    <template v-slot:default v-if="menu2 === true">
      <date-range-picker
        ref="picker"
        opens="inline"
        :close-on-esc="false"
        :showDropdowns="true"
        :locale-data="{ firstDay: 1, format: 'yyyy-mm-dd HH:MM' }"
        control-container-class="form-control border-0 bg-transparent d-none"
        :min-date="new Date().toLocaleDateString()"
        :time-picker-increment="1"
        :time-picker="true"
        class="max-w-550px"
        v-model="date"
      >
        <template v-slot:footer="picker">
          <div
            class="drp-buttons py-4 px-6 poppins d-flex justify-content-end align-items-center"
          >
            <div class="d-flex align-center">
              <button
                type="button"
                class="btn btn-light ls1 py-2 px-4"
                @click="
                  () => {
                    picker.clickCancel();
                    handleDialog();
                  }
                "
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn--print-upload ls1 py-2 px-3"
                @click="
                  () => {
                    picker.clickApply();
                    handleDialog(picker.rangeText);
                  }
                "
              >
                Apply
              </button>
            </div>
          </div>
        </template>
      </date-range-picker>
    </template>
  </v-dialog>
  <!--  </v-menu>-->
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
  name: "DateRangePickerForRules",
  components: {
    DateRangePicker,
  },
  props: ["errorMessages", "onBlur", "value"],
  mounted() {
    if (this.value) {
      this.date = { startDate: this.value[0], endDate: this.value[1] };
      this.inputValue = this.value.join(" - ");
    }
  },
  data: () => {
    let startDate = new Date();

    const startDatesMonth = startDate.getMonth();
    startDate.setMonth(startDatesMonth - 1);
    startDate.setDate(1);
    startDate.setHours(0, 0);

    let endDate = new Date();
    endDate.setHours(23, 59);

    return {
      date: { startDate: null, endDate: null },
      inputValue: null,
      menu2: false,
    };
  },
  methods: {
    resetFilterData() {
      let startDate = new Date();

      const startDatesMonth = startDate.getMonth();
      startDate.setMonth(startDatesMonth - 1);
      startDate.setDate(1);
      startDate.setHours(0, 0);

      let endDate = new Date();
      endDate.setHours(23, 59);

      this.date = { startDate: null, endDate };

      this.inputValue = null;
    },
    handleDialog(rangeText) {
      if (rangeText) {
        const dateArray = rangeText.split(" - ");
        const splitDates = dateArray.map((date) => date.substring(0, 16));

        this.$emit("on-submit", splitDates);
        this.inputValue = rangeText;
      } // else this.inputValue = "";
      setTimeout(() => {
        this.$refs.picker.togglePicker(false);
        this.menu2 = false;
      }, 100);
    },
  },
};
</script>

<style lang="scss">
.table-condensed {
  // .off {
  //   visibility: hidden;
  // }
  .off.in-range {
    background-color: #ebf4f8 !important;
  }
}
.daterangepicker .drp-calendar td.end-date {
  background-color: rgba(183, 4, 126, 0.8) !important;
}
.calendar-time {
  .form-control {
    padding-inline-start: 11px !important;
  }
}
</style>
